export default "__VITE_ASSET__BCx$dIXm__"